var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid",attrs:{"id":"content"}},[_c('HeaderTab',{attrs:{"title":_vm.title,"return_action":'back_action'}}),_c('label',[_vm._v(_vm._s(_vm.title))]),_vm._v(" Fonctionnalité bientot disponible. ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }